import {DrugItemFormDialogsIds} from '@/modules/drug-catalog/constants'
import {MedicationProfileFormDialog} from '@/modules/drug-catalog/medication-profiles/components/medication-profile-form-dialog'
import {dialog} from '@cypro/ui/components'
import {ComponentProps} from 'react'

const dialogId = DrugItemFormDialogsIds.medicationProfile

export function openMedicationProfileFormDialog(props: ComponentProps<typeof MedicationProfileFormDialog>) {
  try {
    dialog.remove(dialogId)
  } catch {}

  return dialog.open(dialogId, {
    scrollBehavior: 'inside',
    size: 'cover',
    children: <MedicationProfileFormDialog {...props} onCancel={closeMedicationProfileFormDialog} />,
    contentProps: {
      overflow: 'hidden',
      height: '100%',
    },
  })
}

export function closeMedicationProfileFormDialog() {
  return dialog.close(dialogId)
}
